import React from 'react';

interface BackArrowIconProps {
  className?: string;
  onClick?: (event: React.MouseEvent<SVGSVGElement>) => void;
  size?: number;
  color?: string;
}

const BackArrowIcon: React.FC<BackArrowIconProps> = ({
  className = "",
  onClick,
  size = 24,
  color = "white"
}) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: 'pointer' }}
    >
      {/* Freccia verso sinistra */}
      <path
        d="M15 18L9 12L15 6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BackArrowIcon;
